export default __webpack_public_path__ + "static/deep-learning-leaders-nav-mobile-0510c99b86e3164a6bb35e5f7ce901f0.avif";